import { givePlannerMinHeight } from "../../components/module-planner/module-planner-height";

const closestByClass = (element, elementClass) => {
  while (element.className !== elementClass) {
    element = element.parentNode;
    if (!element) {
      return null;
    }
  }

  return element;
};

/**
 * This is done to also make it work well in the CMS:
 */
const modulePlannerComponent = document.getElementById(
  "module-planner-component"
);
const modulePlanner = document.getElementById("module-planner-inner-component");

if (modulePlannerComponent) {
  let container = closestByClass(modulePlannerComponent, "grid-container");
  if (container) {
    container.style.zIndex = "3";
  }

  givePlannerMinHeight(modulePlanner);
  window.addEventListener("resize", () => {
    givePlannerMinHeight(modulePlanner);
  });
}
